<template>
   <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 md6 lg4 elevation-6>
        <v-toolbar class="pa-4 tool-bar-app darken-1" style="height: 100%;">
          <v-layout justify-center align-center style="height: 100%;">
            <img class="login--logo" src="@/assets/imagens/logo_mono_cp.png" alt="Logo siged">
          </v-layout>
        </v-toolbar>
        <v-card>
          <form @submit.prevent="confirmar">
            <v-card-text class="pt-4">
                <span class="body-2">
                  Olá, {{username}}!
                </span>
                <br>
                <span class="subheading">Escolha um perfil de acesso</span>
                <v-radio-group class="w-100" v-model="perfil_escolhido">
                    <v-radio color="#25848C" class="rd" ref="focar" v-for="profile in profiles" :key="profile.identificadorusuarioperfil" :value="profile.identificadorusuarioperfil">
                      <div slot="label">
                        <span>{{ profile.nomeperfil }}</span>
                        <!-- <span v-if="isVariasMatriculas"> - Matrícula: {{ profile.cdmatric }}</span> -->
                        <span> - Matrícula: {{ profile.cdpessoal+'-' + profile.cdmatric }}</span>
                      </div>
                    </v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-text>
              <v-btn type="submit" :loading="loading" :disabled="perfil_escolhido === null" class="accent white--text rounded-sm font-weight-regular">
                Usar este perfil
              </v-btn>
            </v-card-text>
          </form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';

export default {
  data(){
    return {
      perfil_escolhido: null,
      loading: false,
    };
  },
  async beforeRouteEnter (to, from, next) {

    if(store.getters.profiles.length === 1) {
      await store.dispatch('alterar_perfil', store.getters.profiles[0].identificadorusuarioperfil);
      if(store.getters.userDadosPerfilAtual.identificadorperfil == 2 && store.getters.schools.length == 0) {
        return next('/logoff');
      }
      return next((store.getters.schools.length) ? '/escolher-escola' : '/');
    }
    next();
  },
  mounted() {
    if(this.profiles.length > 0) {
      this.perfil_escolhido = this.profiles[0].identificadorusuarioperfil;
      this.$refs.focar[0].$el.children[0].children[0].focus();
    }
  },
  methods: {
    escolher_perfil(p){
      this.perfil_escolhido = p;
    },
    async confirmar(){
      this.loading = true;
      await this.alterar_perfil(this.perfil_escolhido);
      if(this.userDadosPerfilAtual.identificadorperfil == 2 && this.schools.length == 0) {
        this.loading = false;
        return this.$router.push('/logoff');
      }

      if(this.userDadosPerfilAtual.identificadorperfil == 1) {
        this.loading = false;
        return this.$router.push('/');
      }
      this.$router.push((this.schools.length) ? '/escolher-escola' : '/');
      this.loading = false;
    },
    ...mapActions(['alterar_perfil']),
  },
  computed: {
    ...mapGetters(['profiles', 'username', 'schools', 'userDadosPerfilAtual']),
    isVariasMatriculas() {
      return this.profiles.filter(key => key.identificadorperfil == 2).length > 1;
    },
  }
}
</script>

<style lang="scss" scoped>
.loginOverlay {
  background-image: url("~@/assets/login-bg.png");
  background-repeat: repeat;
}

.login--logo {
  height: 100%;
}

.w-100{
  width: 100%;
}

.rd{
  border: 1px solid rgba(0, 0, 0, 0.2);
  width: 100%;
  padding: 10px;
  border-radius: 3px;
}
</style>
